module.exports = __webpack_public_path__ + "files/df5ae2e09adf42370d9dacf7d42bc193.png";